<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
      <t-form-item :label="option.attribute.label" class="my_time_picker" :style="setStyles">
       <div v-if="option.attribute.timerange">
         <t-time-range-picker  v-if="option.attribute.timeFormat == 'HH'"    
          v-model="checkedValDate" class="my_time_picker_item" clearable format="HH"     
          :placeholder="option.attribute.placeholder" :status="message" :tips="tips" @change="clickHandler"/>
         <t-time-range-picker  v-if="option.attribute.timeFormat == 'HH:mm'"   
          v-model="checkedValDate" class="my_time_picker_item" clearable format="HH:mm"    
          :placeholder="option.attribute.placeholder" :status="message" :tips="tips" @change="clickHandler"/>
         <t-time-range-picker  v-if="option.attribute.timeFormat == 'HH:mm:ss'"
          v-model="checkedValDate" class="my_time_picker_item" clearable format="HH:mm:ss" 
          :placeholder="option.attribute.placeholder" :status="message" :tips="tips" @change="clickHandler"/>
       </div>
       <div v-else>
          <t-timePicker 
          v-if="option.attribute.timeFormat == 'HH'"
          class="my_time_picker_item"
          v-model="checkedVal"
          :placeholder="option.attribute.placeholder"
          clearable
          format="HH"
          :status="message" :tips="tips"
          @change="clickHandler"
        />
        <t-timePicker 
          v-if="option.attribute.timeFormat == 'HH:mm'"
          class="my_time_picker_item"
          v-model="checkedVal"
          :placeholder="option.attribute.placeholder"
          clearable
          format="HH:mm"
          :status="message" :tips="tips"
          @change="clickHandler"
        />
        <t-timePicker 
          v-if="option.attribute.timeFormat == 'HH:mm:ss'"
          class="my_time_picker_item"
          v-model="checkedVal"
          :placeholder="option.attribute.placeholder"
          clearable
          format="HH:mm:ss"
          :status="message" :tips="tips"
          @change="clickHandler"
        />
       </div>
      </t-form-item>
  </t-form>
</template>

<script>
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-time-picker",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
    components: Array,
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      checkedVal: "",
      // timerange: false,//时间范围开关
      checkedValDate: [],
      message: "default",
      tips: "",
    }
  },
  watch: {
    // 'option.attribute': {
    //   handler(obj) {
    //    console.log(obj,'--') 
    //    if(obj.timerange) {
    //       this.checkedValDate = []
    //    } else {
    //       this.checkedVal = ""
    //    }
    //   },
    //   deep: true
    // },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  computed: {
    cptData() {  //组件绑定的属性
      console.log("======textres====",this.option.cptDataForm.resData);
      if(this.option.cptDataForm.resData){
          return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
      }
    },
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
         "--align": this.option.attribute.align,
         "--timeIcon": this.option.attribute.timeIcon ? 'block' : 'none',
         "--timeIconBg": this.option.attribute.timeIconBg,
         "--panelBg": this.option.attribute.panelBg,
         "--panelColor": this.option.attribute.panelColor,
         "--activeColor": this.option.attribute.activeColor,
         "--activeBgColor": this.option.attribute.activeBgColor,
         "--btnBg": this.option.attribute.btnBg,
         "--btnColor": this.option.attribute.btnColor,
      }
    },
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  mounted() {
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {

        this.refreshCptData();
      
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(
        this.uuid,
        cptDataForm,
        () => {
          this.loadData(cptDataForm, paras);
        },
        this.components
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        // that.jsFunFlag =
        //   cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
        //     ? res.jsFunction
        //     : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);   //监听里面会执行的
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      console.log(cptDataForm, res, jsFunFlag,isFromGrid,1111)
      if (cptDataForm.dataSource == "4") {
            // if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.forEach((item) => {
              let newItem = {};
              dataKey.forEach((mapping) => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });

            let newObject = {
              value: "",
              options: newres,
            };
             this.funselect(newObject)
          }
        // } else {
        //   // 如果配置了转换脚本
        //   this.funselect(res)
        // }
      } else {
        // 不是数据集类型，是静态数据
         this.funselect(res)
      }
    },
    funselect(res) {
      if (this.option.attribute.timerange) {
        this.checkedValDate = res.value
      } else {
        this.checkedVal = res.value
      }
    },
    clickHandler() {
        this.checkValue()
    },
    checkValue() {
      const { attribute } = this.option;
      console.log(this.checkedVal, 'this.checkedVal')
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
  }
}
</script>

<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.t-form :deep(.t-form__controls-content) > div{
  width: 100%;
}
.my_time_picker_item {
  width: 100%;
}
.my_time_picker /deep/ .t-form__label {
   color:var(--textColor);
   font-style: var(--fontStyle);
   font-weight: var(--fontWeight);
   font-family: var(--fontFamily);
   font-size: var(--fontSize);
   line-height: var(--height);
}
.my_time_picker_item /deep/ .t-input .t-input__inner::placeholder {
   color: var(--placholderColor); 
 }

 .my_time_picker_item /deep/ .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: var(--align);
}

.my_time_picker_item  /deep/  .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  height: var(--height);
}

.my_time_picker_item  /deep/  .t-range-input {
   /* min-height: calc(var(--height) + 10px); */
   height: var(--height);
   border:none;
   padding:0px;
}

.my_time_picker_item /deep/ .t-input--focused {
   box-shadow: none !important;
}

.my_time_picker_item /deep/.t-range-input-popup--visible .t-range-input {
   box-shadow: none !important;
}

.my_time_picker_item  /deep/ .t-range-input-popup--visible .t-range-input .t-input.t-is-focused {
  background-color: var(--bgColor);
}

 .my_time_picker_item /deep/ .t-range-input__inner-separator {
  color: var(--textColor);
}

 .my_time_picker_item /deep/  .t-range-input__inner .t-input:hover {
   background-color: var(--bgColor);
}

 .my_time_picker_item /deep/.t-range-input.t-range-input--suffix .t-range-input__suffix {
   display:var(--timeIcon);
   line-height: var(--height);
}

 .my_time_picker_item /deep/.t-input.t-input--suffix > .t-input__suffix-icon {
   display:var(--timeIcon);
   line-height: var(--height);
}
 .my_time_picker_item /deep/ .t-input .t-input__suffix > .t-icon {
    /* color:var(--timeIconBg); */
 }
</style>